<div class="flex flex-col p-4 gap-4">
<h1 class="text-2xl leading-snug">Welches Fest möchten Sie besuchen?</h1>
<app-loading [isLoading]="!festivals()">
  <div class="flex flex-col gap-4">
    <a routerLink="/booking/{{ slugById(festival.id) }}" *ngFor="let festival of festivals()" class="bg-white rounded-xl flex flex-col">
      <img class="rounded-t-xl object-cover" alt="{{festival.title_public}}" src="/titel-{{slugById(festival.id)}}.png" />
      <div class="m-2">
      <h2 class="text-xl">{{ festival.title_public }}</h2>
      Vom {{ festival.valid_from_date | date:'dd. MMMM' }} bis {{ festival.valid_to_date | date:'dd. MMMM yyyy' }}
      </div>
    </a>
  </div>
</app-loading>
</div>
